import * as React from 'react';
import { useContext } from 'react';
import { FileAudioIcon } from '@phosphor-icons/react';
import { FullScreenContext } from '@/app/contexts';
import { getCompactPreviewDisplayUrl } from '@/shared/timelineThumbnails';
import { useTimePilotT } from '@/i18n/useTimePilotT';
import type { MediaSource } from '@/shared/types';

const TABLE_EMPTY_PROMPT_CLASS =
  'px-1 text-center text-[11px] font-medium leading-4 text-white/65';

const Media = React.memo((props: {
  value: { id: string; mediaType: string; mediaSrc: string; mediaUrl: string },
  showType: boolean,
  width: number,
  height: number,
  isInModal: boolean,
  column?: { getActualWidth?: () => number },
  node?: { id?: string },
}) => {
  const { isFullscreen } = useContext(FullScreenContext);
  const t = useTimePilotT();
  const raw = props?.value as unknown;
  const mediaItem = (
    Array.isArray(raw) ? raw[0] : raw
  ) as MediaSource | undefined;
  const previewSrc = getCompactPreviewDisplayUrl(mediaItem);
  const isAudio = mediaItem?.mediaType === 'audio';

  return (
    <div className="box-border flex h-full w-full items-center justify-center overflow-hidden">
      {previewSrc && !isFullscreen ? (
        <img
          src={previewSrc}
          alt=""
          data-testid="table-media-thumbnail"
          className="h-full w-full object-contain"
        />
      ) : isAudio ? (
        <div
          className="flex size-full items-center justify-center"
          data-testid="table-media-audio-icon"
        >
          <FileAudioIcon size={32} className="text-white/80" />
        </div>
      ) : (
        <span
          className={TABLE_EMPTY_PROMPT_CLASS}
          data-testid="table-media-add-thumbnail"
        >
          {t('media.addPreview')}
        </span>
      )}
    </div>
  );
});

Media.displayName = 'Media';

export default Media;
